import { ReportTemplate } from './ReportTemplate'

export class ReportTemplateRouteTripGeneral extends ReportTemplate {
	constructor(...args) {
		super(...args)
		this.set('type', ReportTemplate.Type.RouteTripGeneral)
	}

	static testProperties(properties) {
		return properties.type === ReportTemplate.Type.RouteTripGeneral
	}
}
